import { render, staticRenderFns } from "./InlineTeam.vue?vue&type=template&id=0bd40e66&"
import script from "./InlineTeam.vue?vue&type=script&lang=js&"
export * from "./InlineTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports